import Vue from "vue"
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB0uuEujwU5SI0F9iGXz6jPkS5Bzard0M8",
    libraries: "places" // necessary for places input
  }
})